import { put, call, delay } from 'redux-saga/effects';
import { Types } from './actions';
import ReinforcementRepository from '../../../repositories/ReinforcementRepository';
import ReinforcementDataRepository from '../../../../data/repositories/ReinforcementDataRepository';
import config from '../../../../core/config/config';

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_COURSES_WITH_REINFORCEMENTS_REQUEST });
    const reinforcementRepository: ReinforcementRepository =
      new ReinforcementDataRepository();
    const reinforcementResponse = yield call(
      reinforcementRepository.getCoursesWithReinforcements
    );
    if (!reinforcementResponse) {
      yield put({
        type: Types.GET_COURSES_WITH_REINFORCEMENTS_FAILURE,
        error: true
      });
      return;
    }
    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1500);
    yield put({
      type: Types.GET_COURSES_WITH_REINFORCEMENTS_SUCCESS,
      data: reinforcementResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_COURSES_WITH_REINFORCEMENTS_FAILURE,
      error:
        'Ocurrió un error al momento de leer los datos de los reforzamientos.'
    });
  }
}
